<template>
  <b-card title="SEO">
    <b-card-sub-title class="mb-2">
      Arama motorlarında görünen başlık ve açıklama. Boş bırakılan alanlar sayfa içeriğinden otomatik üretilir.
    </b-card-sub-title>
    <b-form-group
      label="Meta Başlık"
      label-for="meta_title"
    >
      <b-form-input
        id="meta_title"
        v-model="itemData.meta_title"
        placeholder="Boş bırakılırsa sayfa başlığı kullanılır"
      />
      <div class="text-muted mt-1">
        Başlık Uzunluğu: {{ itemData.meta_title? itemData.meta_title.length : 0 }} / 60
        <div class="font-small-2 text-info">
          Önerilen Uzunluk: 60 karakter. Tarayıcı sekmesinde ve arama sonucunda yazdığınız şekliyle görünür.
        </div>
      </div>
    </b-form-group>
    <b-form-group
      label="Meta Açıklama"
      label-for="meta_desc"
    >
      <b-form-textarea
        id="meta_desc"
        v-model="itemData.meta_desc"
        placeholder="Boş bırakılırsa sayfa metninden üretilir"
        rows="3"
      />
      <div class="text-muted mt-1">
        Açıklama Uzunluğu: {{ itemData.meta_desc? itemData.meta_desc.length : 0 }} / 155
        <div class="font-small-2 text-info">
          Önerilen Uzunluk: 155 karakter
        </div>
      </div>
    </b-form-group>
    <b-form-group
      label="Anahtar Kelimeler"
      label-for="meta_keywords"
      class="mb-0"
    >
      <b-form-textarea
        id="meta_keywords"
        v-model="itemData.meta_keywords"
        placeholder="Virgülle ayırın"
        rows="2"
      />
    </b-form-group>
  </b-card>
</template>

<script>
import {
  BCard, BCardSubTitle, BFormGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'SeoCard',
  components: {
    BCard,
    BCardSubTitle,
    BFormGroup,
    BFormInput,
    BFormTextarea,
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
}
</script>
